import { z } from "zod";

import { ALFRED_STATUSES } from "../../alfred/alfred.ts";

/**
 * Lo de Alfred que viaja en la URL: el estado por el que se filtra la
 * lista. El detalle valida la misma, así que «Volver» regresa al mismo
 * filtro. `?c` y `?p` son de la raíz y se conservan solos.
 */
export const alfredSearchSchema = z.object({
  estado: z.enum(ALFRED_STATUSES).optional().catch(undefined),
});

export type AlfredSearch = z.infer<typeof alfredSearchSchema>;
